import { array, defineAction, number, object, string, enumerated } from '~/prix'
import geoReverseGeocodingAction from './geoReverseGeocoding.action.json' with { type: 'json' }
import any from '~/prix/types/any'

const geoReverseGeocodingDefinition = defineAction({
  ...geoReverseGeocodingAction,

  input: object({
    latitude: number().label('Latitude do ponto a ser geocodificado.'),
    longitude: number().label('Longitude do ponto a ser geocodificado.'),
    include: array(string()).label('Campos adicionais a serem incluídos na resposta.'),
    limit: number().label('Número máximo de resultados a serem retornados.'),
  }),
  output: object({
    results: any().label('Resultados da geocodificação reversa.'),
  }),
})

export default geoReverseGeocodingDefinition
